import React, { Component } from "react";
import ReactModal from "react-modal";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import LoginVerification from "../common/loginVerification";
import axios from "axios";

import "./registrationForm.css";
import SglContext from "../SglContext";

// IMPORT IMAGES
import indicator_icon from "../images/Indicator.gif";
import tick_icon from "../images/tick_icon.png";
import close_icon from "../images/close.png";
import PasswordStrengthMeter from "../common/PasswordStrengthMeter"

//API END POINTS
// const sgl_webservice_terms_of_service =
//   process.env.REACT_APP_SGL_API +
//   "/iphone.php/webservice/GetTermsOfServiceForRegistration";
// const sgl_webservice_excluded_countries =
//   process.env.REACT_APP_SGL_API +
//   "/iphone.php/webservice/GetRegRestrictedCountries";
// const sgl_webservice_clear_session_values =
//   process.env.REACT_APP_SGL_API + "/iphone.php/webservice/ClearSessionValues";

// const sgl_webservice_verify_mobile =
//   process.env.REACT_APP_SGL_API + "/iphone.php/webservice/VerifyMobilePhone";
// const sgl_webservice_verify_otp =
//   process.env.REACT_APP_SGL_API + "/iphone.php/webservice/VerifyOTP";
// const sgl_webservice_process_registration =
//   process.env.REACT_APP_SGL_API +
//   "/iphone.php/webservice/ProcessRegisterationData";
// const sgl_user_requests = process.env.REACT_APP_NEST_API + "/user-requests/registration/";
// const get_pending_verify_user_action =  process.env.REACT_APP_NEST_API + "/milestone-actions/getPendingVerifyUserAction";

var AddModal = ReactModal;

function RegistrationForm(props) {
  const [termsOfService, setTermsOfService] = useState("");
  const [excludeCountries, setExcludeCountries] = useState([]);
  const [ratedShows, setRatedShows] = useState("");
  const [loading, setLoading] = useState(true);
  const [verifyMobileOpenState, setVerifyMobileOpenState] = useState(false);
  const [formTouched, setFormTouched] = useState(false);
  const [password, setPassword] = useState("");
  const [verifyMembership, setVerifyMembership] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [error, setError] = useState('');
  const [load, setLoad] = useState(false);
  const [urt, setUrt] = useState("");
  const [fromParentAttestation, setFromParentAttestation] = useState(false);
  const [userData, setUserData] = useState({
    sgl_id: 0,
    first: "",
    last_name: "",
    full_name: "",
    address: "",
    city: "",
    state: "",
    postal_code: "",
    email_address: "",
    phonenumber: "",
    phonenumber_verified: 0,
  });
  const [mobileNumber, setMobileNumber] = useState({
    isValid: false,
    rawValue: null,
    countryData: null,
    formattedValue: "",
    extension: null,
  });

  const Sgl = useContext(SglContext);

  //API END POINTS
  const sgl_webservice_terms_of_service =
    Sgl.sglApiUrl +
    "/iphone.php/webservice/GetTermsOfServiceForRegistration";
  const sgl_webservice_excluded_countries =
    Sgl.sglApiUrl +
    "/iphone.php/webservice/GetRegRestrictedCountries";
  const sgl_webservice_clear_session_values =
    Sgl.sglApiUrl + "/iphone.php/webservice/ClearSessionValues";

  const sgl_webservice_verify_mobile =
    Sgl.sglApiUrl + "/iphone.php/webservice/VerifyMobilePhone";
  const sgl_webservice_verify_otp =
    Sgl.sglApiUrl + "/iphone.php/webservice/VerifyOTP";
  const sgl_webservice_process_registration =
    Sgl.sglApiUrl +
    "/iphone.php/webservice/ProcessRegisterationData";
  const sgl_user_requests = Sgl.nestApiUrl + "/user-requests/registration/";
  const get_pending_verify_user_action =  Sgl.nestApiUrl + "/milestone-actions/getPendingVerifyUserAction";


  const navigate = useNavigate();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function validatePassword(pw) {
    // At least 8 chars, 1 uppercase, 1 lowercase, 1 digit, 1 special char
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/.test(pw);
  }

  function validateForm() {
    const errors = {};
    if (!userData.email_address || !emailRegex.test(userData.email_address)) {
      errors.email = 'Please enter a valid email address.';
    }
    if (!password || !validatePassword(password)) {
      errors.password = 'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one digit, and one special character.';
    }
    if (!userData.first) errors.first = 'First name is required.';
    if (!userData.last_name) errors.last = 'Last name is required.';
    if (!userData.address) errors.address = 'Address is required.';
    const city = document.getElementById('city')?.value || '';
    const stateVal = document.getElementById('state')?.value || '';
    const postalcode = document.getElementById('postalcode')?.value || '';
    if (!city.trim()) errors.city = 'City is required.';
    if (!stateVal.trim()) errors.state = 'State is required.';
    if (!postalcode.trim()) errors.postalcode = 'Postal code is required.';
    if (!mobileNumber.isValid || !userData.phonenumber) {
      errors.phonenumber = 'Please enter and verify a valid mobile number. ';
    }
    if (userData.phonenumber_verified !== 1) {
      errors.phonenumber_verified = 'Mobile number must be verified.';
    }
    if (!ratedShows) {
      errors.ratedShows = 'Please select whether you are participating in any rated shows.';
    }
    return errors;
  }

  useEffect(() => {
    const errors = validateForm();
    setValidationErrors(errors);
  }, [userData, password, mobileNumber, ratedShows]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urtValue = params.get("urt");
    const parentValue = params.get("parent");
    setUrt(urtValue);
    setFromParentAttestation(parentValue)
  }, []);
  
  useEffect(() => {
    setPassword("");
    fetchUserRequest();
  }, [urt]);

  const fetchUserRequest = async () => {
    if (urt) {
      try {
        setLoad(true);
        const response = await axios.get(sgl_user_requests + urt);
        if (response.data && response.data.email_address) {
          setUserData((prev) => ({
            ...prev,
            email_address: response.data.email_address
          }));
        }
      } catch (error) {
        setLoad(false);
        setError(error.response?.data?.message || error.message || "Invalid or expired request.");
        console.error("Error fetching user request:", error);
      }
      finally {
        setLoad(false);
      }
    }
  }

  useEffect(() => {
    Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_urlpath + '/registration');
    Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_urlpath + '/registration');
    let sgl_plugin_form = document.getElementById("sgl-plugin-form");
    sgl_plugin_form.style.display = "block";
    let phone_input = document.querySelector("#telephone-input");
  }, []);

  useEffect(() => {

    axios.all([
      axios.get(sgl_webservice_excluded_countries),
      axios.get(sgl_webservice_terms_of_service, {
        params: {
          customer_id: Sgl.company_id,
        },
      })
    ]).then(axios.spread((countries_obj, terms_obj) => {
      setExcludeCountries(countries_obj.data);
      setTermsOfService(terms_obj.data);
      setLoading(false);

    }))
    // axios
    //   .get(sgl_webservice_terms_of_service, {
    //     params: {
    //       customer_id: Sgl.company_id,
    //     },
    //   })
    //   .then((res) => {
    //     setTermsOfService(res.data);
    //     setLoading(false);
    //   });
  },[]);

  const handleRadioChange = (e) => {
    setRatedShows(e.target.value);
  }

  const handleSkipVerification = async () => {
    navigate('/login');
  }

  function handleChange(e) {
    const { name, value } = e.target;

    // Map input to correct names in userData
    const fieldName = name == "email" ? "email_address" : name == "last" ? "last_name" : name =="postalcode" ? "postal_code" : name;

    setUserData((prev) => {
      // Auto-generate full_name if first or last_name changes
      if (fieldName == "first") {
        return {
          ...prev,
          first: value,
          full_name: `${value} ${prev.last_name}`.trim(),
        };
      }
      if (fieldName == "last_name") {
        return {
          ...prev,
          last_name: value,
          full_name: `${prev.first} ${value}`.trim(),
        };
      }
      return { ...prev, [fieldName]: value };
    });
  }

  function handleBlur() {
    let errorContainer_top = document.getElementById("reg_error_summary_top");
    let errorContainer_bottom = document.getElementById(
      "reg_error_summary_bottom"
    );

    if (mobileNumber.formattedValue === "" || mobileNumber.isValid) {
      errorContainer_top.innerHTML = "";
      errorContainer_top.style.display = "none";
      errorContainer_bottom.innerHTML = "";
      errorContainer_bottom.style.display = "none";
    } else {
      errorContainer_top.innerHTML = "Please enter valid mobile number";
      errorContainer_top.style.display = "block";
      errorContainer_bottom.innerHTML = "Please enter valid mobile number";
      errorContainer_bottom.style.display = "block";
    }
  }

  function reset() {
    let phone_input_hidden = document.getElementById("telephone-input");
    phone_input_hidden.value = "";
  }

  function verifyMobile() {
    let errorContainer_top = document.getElementById("reg_error_summary_top");
    let errorContainer_bottom = document.getElementById(
      "reg_error_summary_bottom"
    );
    let verify_mobile_button = document.getElementById("verifyMobile_btn");
    let please_wait = document.getElementById("verify_mobile-please-wait");

    if (!mobileNumber.isValid) {
      errorContainer_top.innerHTML = "Please enter valid mobile number";
      errorContainer_top.style.display = "block";
      errorContainer_bottom.innerHTML = "Please enter valid mobile number";
      errorContainer_bottom.style.display = "block";
      verify_mobile_button.style.display = "block";
      please_wait.style.display = "none";
      return 0;
    } else {
      errorContainer_top.innerHTML = "";
      errorContainer_top.style.display = "none";
      errorContainer_bottom.innerHTML = "";
      errorContainer_bottom.style.display = "none";
      verify_mobile_button.style.display = "none";
      please_wait.style.display = "block";
    }


    axios
      .get(sgl_webservice_verify_mobile, {
        params: {
          mobile_phone: mobileNumber.formattedValue,
          dial_code: mobileNumber.countryData.dialCode,
          urt: urt || "",
        },
      })
      .then((response) => {
        if (response.data.result) {
          setVerifyMobileOpenState(true);
          setUserData((prev) => ({
            ...prev,
            phonenumber_verified: 1,
          }));
        } else {
          errorContainer_top.innerHTML = response.data.error;
          errorContainer_top.style.display = "block";
          errorContainer_bottom.innerHTML = response.data.error;
          errorContainer_bottom.style.display = "block";
          verify_mobile_button.style.display = "block";
          please_wait.style.display = "none";
        }
      });
  }

  function verifyOTP() {
    let otp_please_wait = document.getElementById("verify_otp-please-wait");
    let otp_verify_btn = document.getElementById("verify_otp_btn");
    let otp_error_summary = document.getElementById("verify_otp_error_summary");
    let verify_mobile_button = document.getElementById("verifyMobile_btn");
    let mobile_verified = document.getElementById("mobile-verified");
    let otp = document.getElementById("otp");
    let phone_input_hidden = document.getElementById("telephone");
    let phone_input = document.getElementById("telephone-input");
    let please_wait = document.getElementById("verify_mobile-please-wait");

    otp_please_wait.style.display = "block";
    otp_verify_btn.style.display = "none";
    otp_error_summary.style.display = "none";

    axios
      .get(sgl_webservice_verify_otp, {
        params: {
          otp: otp.value,
          urt: urt || "",
        },
      })
      .then((response) => {
        otp_please_wait.style.display = "none";
        if (response.data.result) {
          verify_mobile_button.style.display = "none";
          mobile_verified.style.display = "block";
          please_wait.style.display = "none";
          // phone_input_hidden.readOnly = true;
          // phone_input.readOnly = true;

          setVerifyMobileOpenState(false);
        } else {
          otp_error_summary.innerHTML = response.data.error;
          otp_error_summary.style.display = "block";
          otp_verify_btn.style.display = "block";
        }
      });
  }

  function closeVerifyMobile(e) {
    e.preventDefault();
    let verify_mobile_button = document.getElementById("verifyMobile_btn");
    let please_wait = document.getElementById("verify_mobile-please-wait");

    setVerifyMobileOpenState(false);
    please_wait.style.display = "none";
    verify_mobile_button.style.display = "block";
  }

  function showTermsAndConditions() {
    document.getElementById("terms_and_conditions_cont").style.display =
      "block";
    document.getElementById("terms_cond_overlay").style.display = "block";
    document.getElementById("terms_and_conditions_cont").style.zIndex = 9999;
    document.getElementById("terms_cond_overlay").style.zIndex = 9999
    window.scrollTo(0, 0);
  }

  function hideTermsAndConditions() {
    document.getElementById("terms_and_conditions_cont").style.display = "none";
    document.getElementById("terms_cond_overlay").style.display = "none";
  }

  let handlePasswordChange = event => {
    setPassword(event.target.value)
  } 

  async function processRegistration() {
    let email = document.getElementById("email");
    let pass = document.getElementById("pass");
    let conf_pass = document.getElementById("conf_pass");
    let first = document.getElementById("first");
    let last = document.getElementById("last");
    let address = document.getElementById("address");
    let city = document.getElementById("city");
    let state = document.getElementById("state");
    let postalcode = document.getElementById("postalcode");
    let telephone = document.getElementById("telephone");
    let errorContainer_top = document.getElementById("reg_error_summary_top");
    let errorContainer_bottom = document.getElementById(
      "reg_error_summary_bottom"
    );

    errorContainer_top.innerHTML = "";
    errorContainer_top.style.display = "none";
    errorContainer_bottom.innerHTML = "";
    errorContainer_bottom.style.display = "none";

    if (!ratedShows) {
      // alert("Please select whether you are participating in any rated shows.");
      let errorContainer_top = document.getElementById("reg_error_summary_top");
      let errorContainer_bottom = document.getElementById("reg_error_summary_bottom");
      errorContainer_top.innerHTML = "Please select whether you are participating in any rated shows.";
      errorContainer_top.style.display = "block";
      errorContainer_bottom.innerHTML = "Please select whether you are participating in any rated shows.";
      errorContainer_bottom.style.display = "block";
      return; // stop submission
    }

    const response = await axios.post(sgl_webservice_process_registration, null, {
      params: {
        email: email.value,
        pass: pass.value,
        conf_pass: conf_pass.value,
        first: first.value,
        last: last.value,
        address: address.value,
        city: city.value,
        state: state.value,
        postalcode: postalcode.value,
        telephone: mobileNumber.formattedValue,
        customer_id: Sgl.company_id,
        urt: urt || "",
        site_url: `${window.location.protocol}//${window.location.host}${(Sgl.basePath != '/' && Sgl.basePath != '')?`${Sgl.basePath}`:""}`,
        rated_shows: ratedShows,
      },
    });

    if (response.data.status) {
      if (response?.data?.user_id) {
        
        return response?.data?.user_id;
      } else {
        const msg = "An error occurred during registration. Please try again.";
        errorContainer_top.innerHTML = msg;
        errorContainer_top.style.display = "block";
        errorContainer_bottom.innerHTML = msg;
        errorContainer_bottom.style.display = "block";
        throw new Error(msg);
      }
    } else {
      const messages = Array.isArray(response.data.message)
        ? response.data.message
        : [response.data.message || "Unknown error occurred."];

      const formatted = messages.join("<br/>");

      errorContainer_top.innerHTML = formatted;
      errorContainer_top.style.display = "block";
      errorContainer_bottom.innerHTML = formatted;
      errorContainer_bottom.style.display = "block";

      console.error("Registration error:", messages);
      throw new Error(messages.join(" | "));
    }
  }

  function handlePhoneNumberChange(
    _isValid,
    _rawValue,
    _countryData,
    _formattedValue,
    _extension
  ) {
    setMobileNumber({
      isValid: _isValid,
      rawValue: _rawValue,
      countryData: _countryData,
      formattedValue: _formattedValue,
      extension: _extension,
    });

    setUserData((prev) => ({
      ...prev,
      phonenumber: _formattedValue,
    }));
  }

  async function handleContinue(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setFormTouched(true);
    const errors = validateForm();
    setValidationErrors(errors);

    // If there are errors, do not continue
    if (Object.keys(errors).length > 0) {
      return;
    }

    let userId;
    try {
      userId = await processRegistration();
      if (!userId) {
        throw new Error("Failed to fetch userId from registration");
      }
      
      // Update sgl_id in userData
      setUserData((prev) => ({
        ...prev,
        sgl_id: userId,
      }));
    } catch (err) {
      console.error("Login verification error:", err);
      throw new Error(err.message);
    }

    if (ratedShows === "yes") {
      try {
        const response = await axios.get(get_pending_verify_user_action, {
          params: { user_id: userId, customer_id: Sgl.company_id }
        })

        if (response.data?.hasPendingAction) {
          setVerifyMembership(true);
        } else {
          // Display registration success message
          let sgl_plugin_form = document.getElementById("sgl-plugin-form");
          let sgl_plugin_success_message = document.getElementById(
            "sgl-plugin-success-message"
          );

          sgl_plugin_form.innerHTML = "";
          sgl_plugin_form.style.display = "none";
          sgl_plugin_success_message.style.display = "block";
        }
      } catch (err) {
        console.error("Error getting pending verify action for user: ", err);
        throw new Error(err.message);
      }
    } else {
      // Display registration success message
      let sgl_plugin_form = document.getElementById("sgl-plugin-form");
      let sgl_plugin_success_message = document.getElementById(
        "sgl-plugin-success-message"
      );

      sgl_plugin_form.innerHTML = "";
      sgl_plugin_form.style.display = "none";
      sgl_plugin_success_message.style.display = "block";
      
    }
  }

  async function handleProcessRegistration(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setFormTouched(true);
    const errors = validateForm();
    setValidationErrors(errors);

    // If there are errors, do not continue
    if (Object.keys(errors).length > 0) {
      return;
    }

    try {
      const userId = await processRegistration();
      if (!userId) {
        throw new Error("Failed to fetch userId from registration");
      }

      let sgl_plugin_form = document.getElementById("sgl-plugin-form");
      let sgl_plugin_success_message = document.getElementById(
        "sgl-plugin-success-message"
      );

      sgl_plugin_form.innerHTML = "";
      sgl_plugin_form.style.display = "none";
      sgl_plugin_success_message.style.display = "block";

      if(fromParentAttestation) {
        navigate('/edit-account/#pending_requests');
      }
    } catch (err) {
      console.error("Error during registration: ", err);
      throw new Error(err.message);
    }
  }

  function handleBack() {
      setVerifyMembership(false);
  }

  if (load) {
    return (
      <div className="accept-request-page">
        <div className="accept-request-container">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <h2 className="loading-title">Loading request details...</h2>
            <p className="loading-message">Please wait while we verify your request</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="accept-request-page">
        <div className="accept-request-container">
          <div className="error-container">
            <div className="error-header">
              <div className="error-icon">✕</div>
              <h1 className="error-title">Request Error</h1>
            </div>
            <div className="error-body">
              <p className="error-message">{error}</p>
              <div className="error-actions">
                <button className="modern-btn modern-btn-primary" onClick={fetchUserRequest}>
                  Try Again
                </button>
                <button className="modern-btn modern-btn-secondary" onClick={() => navigate('/dashboard')}>
                  Go to Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='sgl-content-wrapper registrationformcss'>
      <div className='sgl-plugin'>
        <div className='registration_header'>
          <h1>{Sgl.company_name} - REGISTRATION</h1>
        </div>
        <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div>
        <br />
        <div id='sgl-plugin-form'>
          {/* form start */}
          <div className='div-responsive'>
            <div className='registration-container'>
              <div style={{ display: verifyMembership ? 'none' : 'block' }}>
                <div className='reg_message'>
                  <div>
                    <p>
                      Fill the form below to begin your registration.
                      <br />
                      You must have a valid email address to register for{" "}
                      {Sgl.company_name}
                    </p>
                  </div>

                  <div className='error_container display_on_mobile'>
                    <div>
                      <p
                        className='error_summary reg_error_summary '
                        id='reg_error_summary_top'></p>
                    </div>
                  </div>
                </div>

                <div className='full'>
                  <input
                    type='text'
                    placeholder='Email'
                    name='email'
                    id='email'
                    value={urt ? userData.email_address : undefined}
                    readOnly={urt ? true : false}
                    onChange={handleChange}
                  />
                  {formTouched && validationErrors.email && <span style={{color:'red'}}>{validationErrors.email}</span>}
                </div>

                <div className='full'>
                  <input
                    type='password'
                    placeholder='Password'
                    name='pass'
                    id='pass'
                    onChange={handlePasswordChange}
                  />
                  { password && <PasswordStrengthMeter password={password} /> }
                  {formTouched && validationErrors.password && <span style={{color:'red'}}>{validationErrors.password}</span>}
                </div>
                <div className='full'>
                  <input
                    type='password'
                    placeholder='Confirm Password'
                    name='conf_pass'
                    id='conf_pass'
                  />
                </div>

                <div className='full'>
                  <div className='half'>
                    <input
                      type='text'
                      placeholder='First Name'
                      id='first'
                      name='first'
                      onChange={handleChange}
                    />
                    {formTouched && validationErrors.first && <span style={{color:'red'}}>{validationErrors.first}</span>}
                  </div>

                  <div className='half'>
                    <input
                      type='text'
                      placeholder='Last Name'
                      name='last'
                      id='last'
                      onChange={handleChange}
                    />
                    {formTouched && validationErrors.last && <span style={{color:'red'}}>{validationErrors.last}</span>}
                  </div>
                </div>

                <div className='full'>
                  <input
                    type='text'
                    placeholder='Address'
                    name='address'
                    id='address'
                    onChange={handleChange}
                  />
                  {formTouched && validationErrors.address && <span style={{color:'red'}}>{validationErrors.address}</span>}
                </div>

                <div className='full'>
                  <div className='half'>
                    <input type='text' placeholder='City' name='city' id='city' onChange={handleChange} />
                    {formTouched && validationErrors.city && <span style={{color:'red'}}>{validationErrors.city}</span>}
                  </div>

                  <div className='half'>
                    <input
                      type='text'
                      placeholder='State'
                      name='state'
                      id='state'
                      onChange={handleChange}
                    />
                    {formTouched && validationErrors.state && <span style={{color:'red'}}>{validationErrors.state}</span>}
                  </div>
                </div>

                <div className='full'>
                  <div className='half'>
                    <input
                      type='text'
                      placeholder='Postal Code'
                      name='postalcode'
                      id='postalcode'
                      onChange={handleChange}
                    />
                    {formTouched && validationErrors.postalcode && <span style={{color:'red'}}>{validationErrors.postalcode}</span>}
                  </div>

                  <div className='half'>
                  { !loading ?
                    <IntlTelInput
                      style={{
                        width: "100%",
                      }}
                      preferredCountries={["us", "ca"]}
                      initialCountry={"us"}
                      allowDropdown={true}
                      onPhoneNumberChange={handlePhoneNumberChange}
                      onPhoneNumberBlur={handleBlur}
                      placeholder='Mobile Number'
                      id='telephone-input'
                      excludeCountries={excludeCountries}
                    />
                    :null
                    }

                    <input type='hidden' name='telephone' id='telephone' />
                    {formTouched && validationErrors.phonenumber && <span style={{color:'red'}}>{validationErrors.phonenumber}</span>}
                    {formTouched && validationErrors.phonenumber_verified && <span style={{color:'red'}}>{validationErrors.phonenumber_verified}</span>}
                  </div>
                </div>

                <div className='full'>
                  <a
                    href='javascript:void(0);'
                    id='verifyMobile_btn'
                    onMouseDown={verifyMobile}
                    className='link'>
                    Verify Mobile
                  </a>
                  <span id='verify_mobile-please-wait'>
                    <img src={indicator_icon} /> Verifiying...
                  </span>
                  <span id='mobile-verified'>
                    <img src={tick_icon} /> Verified{" "}
                  </span>
                </div>

                <div className='error_container'>
                  <div>
                    <p
                      className='error_summary reg_error_summary'
                      id='reg_error_summary_bottom'></p>
                  </div>
                </div>

                {/* Rated shows question */}
                <div className='full'>
                  <div style={{ display: "flex", gap: "1rem", alignItems: "baseline" }}>
                    <p>Are you participating in any rated shows?</p>
                    <label>
                      <input type="radio" name="rated_shows" value="yes" checked={ratedShows == "yes"} onChange={handleRadioChange} /> Yes
                    </label>
                    <label>
                      <input type="radio" name="rated_shows" value="no" checked={ratedShows == "no"} onChange={handleRadioChange} /> No
                    </label>
                  </div>
                  {formTouched && validationErrors.ratedShows && <span style={{color:'red'}}>{validationErrors.ratedShows}</span>}
                </div>             
              </div>

              {/* Show LoginVerification when "Yes" is selected and there are no validation errors */}
              {verifyMembership && (
                <LoginVerification
                  fromRegister={true}
                  userData={userData}
                  onComplete={handleSkipVerification}
                />
              )}

              <div style={{ display: verifyMembership ? 'none' : 'block' }}>
                <div className='full terms' style={{}}>
                  By creating an account, you agree to our{" "}
                  <a
                    href='javascript:void(0);'
                    onClick={showTermsAndConditions}
                    className='link'>
                    Terms &amp; Conditions
                  </a>
                </div>

                <div className='full submit'>
                  <input
                    type='button'
                    id='update'
                    onClick={ratedShows === "yes" && !verifyMembership ? handleContinue : handleProcessRegistration}
                    value='Register'
                  />
                </div>
              </div>
            </div>
          </div>
          {/* form end */}

          {/*terms and conditions start*/}
          <div className='terms_cond_overlay' id='terms_cond_overlay'></div>

          <div
            className='terms_and_conditions_cont'
            id='terms_and_conditions_cont'>
            <div className='close_terms_cond'>
              <a
                href='javascript:void(0);'
                onClick={hideTermsAndConditions}
                className='link'>
                <img src={close_icon} />
              </a>
            </div>
            <div className='terms_cond_header'>
              <h2>TERMS &amp; CONDITIONS</h2>
            </div>
            <textarea
              className='term_and_conditions_txt'
              id='term_and_conditions_txt'
              value={termsOfService}
            />
          </div>
          {/*terms and conditions end*/}

          <div>
            <AddModal
              isOpen={verifyMobileOpenState}
              // onAfterOpen={afterOpenVerifyMobile}
              onRequestClose={closeVerifyMobile}
              className='mymodal'
              overlayClassName='myoverlay'
              ariaHideApp={false}>
              <h2>Verify Mobile</h2>
              <p>Please enter Verification Code</p>
              <p id='verify_otp_error_summary' className='otp_error_summary'>
                Please enter verification code sent to your phone.
              </p>
              <input
                type='text'
                maxlength='5'
                id='otp'
                name='otp'
                className='otp'
                placeholder='Verification Code'></input>
              <div>
                <button
                  onClick={closeVerifyMobile}
                  className='verify_mobile_buttons left'>
                  Close
                </button>
                <button
                  id='verify_otp_btn'
                  onClick={verifyOTP}
                  className='verify_mobile_buttons right'>
                  Verify
                </button>
                <span id='verify_otp-please-wait' className='verify_otp-please-wait right'>
                  <img src={indicator_icon} /> Processing...
                </span>
              </div>
            </AddModal>
          </div>
        </div>

        <div id='sgl-plugin-success-message'>
          <p>
            Thank you for registering for {Sgl.company_name}
            <br />
            <br />
            {!urt && (
              <>
                A confirmation email has been sent to you. You must access
                your email and confirm the registration prior to logging in.
              </>
            )}
          </p>
        </div>
        <div className='copyright-text'>
          {process.env.REACT_APP_COPYRIGHT_TEXT}
        </div>
      </div>
    </div>
  );
}
export default RegistrationForm;
